
import {
  defineComponent, PropType, computed,
} from '@vue/composition-api';
import {
  useRoute, useRouter,
} from 'vue2-helpers/vue-router';
import { Extension } from '@/lib/api/extension.service';
import ActionButton from '@/components/ActionButton.vue';

const ExtensionDefaultIconUrl = process.env.VUE_APP_EXTENSION_DEFAULT_ICON_URL as string;

export default defineComponent({
  name: 'ExtensionCard',

  props: {
    extension: {
      type: Object as PropType<Extension>,
      required: true,
    },
    maxDescriptionLength: {
      type: Number as PropType<number>,
      default: 140,
    },
    legacy: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },

  components: { ActionButton },

  setup(props) {
    const route = useRoute();
    const router = useRouter();

    const iconUrl = computed(() => props.extension.meta.icon_url || ExtensionDefaultIconUrl);
    const description = computed(() => {
      const desc = props.extension.meta.description;
      if (desc.length > props.maxDescriptionLength) {
        return desc.slice(0, props.maxDescriptionLength).concat('...');
      }
      return desc;
    });
    const detailsRoute = computed(() => {
      if (props.legacy) {
        // Remove `category` from query
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { category, ...queryWithoutCategory } = route.query;
        return {
          name: 'Extension Details Legacy',
          query: {
            baseName: props.extension.meta.baseName,
            ...queryWithoutCategory,
          },
        };
      }
      // Remove `category` from params
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { category, ...paramsWithoutCategory } = route.params;
      return {
        name: 'Extension Details',
        params: {
          baseName: props.extension.meta.baseName,
          ...paramsWithoutCategory,
        },
      };
    });
    const goToDetails = () => {
      router.push(detailsRoute.value);
    };
    return {
      iconUrl,
      description,
      detailsRoute,
      goToDetails,
    };
  },
});
